import React from 'react'
import Image from "./github.png"
function Github() {
  return (
    <img src={Image} style={{width:"30px"}} alt='githubicon' />
  )
}

export default Github